import { CommunicatorService } from 'ui-ng-component-communicator';
import * as _4 from 'lodash4';
import { IQuery } from 'core-ts-types';
import { SectionFiltersQuery } from './queries/section_filters_query';
import { IComponent, ISectionFilters, ISectionLabelValue } from '../../interfaces/scheduler_interfaces';
import { ClearSectionFiltersCommand } from './commands/clear_section_filters_command';
import { GetSectionFiltersCommand } from './commands/get_section_filters_command';
import { SaveSectionFiltersCommand } from './commands/save_section_filters_command';

class SectionFiltersController {
  private isFiltersOpened: boolean;
  private clearExistingFiltersBound: () => void;
  private query: IQuery;
  private showInstructors: boolean = false;
  private showLabels: boolean = false;
  private selectedFilters: ISectionFilters = {
    instructors: [],
    section_labels: []
  };

  constructor(
    private ngComponentCommunicatorService: CommunicatorService,
    private ngSectionFiltersQuery: SectionFiltersQuery,
    private getSectionFiltersCommand: GetSectionFiltersCommand,
    private clearSectionFiltersCommand: ClearSectionFiltersCommand,
    private $stateParams: ng.ui.IStateParamsService,
    private saveSectionFiltersCommand: SaveSectionFiltersCommand,
    private $element: ng.IAugmentedJQuery
  ) {}

  $onInit() {
    this.clearExistingFiltersBound = this.clearExistingFilters.bind(this);
    this.ngComponentCommunicatorService.subscribe('CLEAR_EXISTING_FILTERS', this.clearExistingFiltersBound);
    this.query = this.ngSectionFiltersQuery;
    this.getSectionFiltersCommand(
      this.$stateParams.termId,
      this.$stateParams.courseId,
      this.$stateParams.sectionTypeId
    ).then(() => this.update());
    this.scrollToTop();
  }

  $onChanges() {
    this.update();
  }

  update() {
    this.showInstructors = !_4.isEmpty(this.ngSectionFiltersQuery.result.instructors);
    this.showLabels = !_4.isEmpty(this.ngSectionFiltersQuery.result.section_labels);
  }

  clearExistingFilters() {
    this.clearInputSelections('#instructor_filter_combobox');
    this.clearInputSelections('#section_filters_drawer hi-checkbox-group');
  }

  clearInputSelections(elementSelector: string) {
    const elementToClear = this.$element[0].querySelector(elementSelector) as IComponent;
    if (!_4.isNil(elementToClear) && elementToClear.clear) {
      elementToClear.clear();
    }
  }

  scrollToTop() {
    const sectionFilters = this.$element[0].querySelector('#section_filters_drawer') as IComponent;
    if (!_4.isNil(sectionFilters) && sectionFilters.scroll) {
      sectionFilters.scroll(0, 0);
    }
  }

  onFiltersClosed() {
    this.clearUpdatedSectionFilters();
    this.closeFilters();
  }

  closeFilters() {
    this.isFiltersOpened = false;
  }

  submitFilters(event: JQueryEventObject) {
    const selectedValues = _4.get(event, 'detail.value', []);
    if (this.showInstructors) {
      this.saveUpdatedInstructorFilter(_4.get(selectedValues, 'instructor_filter_combobox', []));
    }
    if (this.showLabels) {
      this.saveUpdatedSectionLabelFilter(_4.get(selectedValues, 'label_filter_checkbox_group', []));
    }
    this.saveSectionFiltersCommand(this.selectedFilters);
    this.clearUpdatedSectionFilters();
    this.closeFilters();
  }

  saveUpdatedInstructorFilter(instructorArray: string[]) {
    this.selectedFilters.instructors = instructorArray;
  }

  saveUpdatedSectionLabelFilter(selectedIds: string[]) {
    const sectionLabels = this.query.result.section_labels;
    _4.forEach(selectedIds, (id) => {
      const label = _4.find(sectionLabels, { id: _4.toInteger(id) }) as ISectionLabelValue;
      this.selectedFilters.section_labels.push(label);
    });
  }

  clearUpdatedSectionFilters() {
    this.selectedFilters = {
      instructors: [],
      section_labels: []
    };
  }

  clearFilters() {
    this.clearSectionFiltersCommand();
    this.clearUpdatedSectionFilters();
  }
}

class SectionFiltersComponent implements ng.IComponentOptions {
  public bindings: any;
  public controller: any;
  public templateUrl: any;
  constructor() {
    this.bindings = {
      course: '<',
      isFiltersOpened: '='
    };
    this.controller = SectionFiltersController;
    this.templateUrl = 'capability-ng-scheduler/src/components/section_filters/section_filters.html';
  }
}

angular.module('capability-ng-scheduler').component('sectionFilters', new SectionFiltersComponent());



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/components/section_filters/section_filters.ts